export default function ShebaFintechSuccessIcon() {
  return (
    <>
      <svg
        width="100"
        height="101"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.375 50.5645C9.375 28.127 27.5625 9.93945 50 9.93945C72.4375 9.93945 90.625 28.127 90.625 50.5645C90.625 73.002 72.4375 91.1895 50 91.1895C27.5625 91.1895 9.375 73.002 9.375 50.5645ZM65.0417 43.0061C65.2917 42.673 65.4725 42.2933 65.5737 41.8892C65.6748 41.4852 65.6942 41.065 65.6306 40.6534C65.5671 40.2418 65.4219 39.8471 65.2036 39.4924C64.9852 39.1377 64.6982 38.8302 64.3594 38.588C64.0206 38.3458 63.6367 38.1738 63.2305 38.0821C62.8242 37.9903 62.4037 37.9808 61.9937 38.0539C61.5836 38.127 61.1924 38.2813 60.8428 38.5078C60.4933 38.7343 60.1926 39.0284 59.9583 39.3728L46.475 58.2478L39.7083 51.4811C39.1159 50.9291 38.3324 50.6286 37.5228 50.6429C36.7132 50.6572 35.9408 50.9851 35.3682 51.5577C34.7957 52.1302 34.4677 52.9027 34.4534 53.7123C34.4391 54.5219 34.7397 55.3054 35.2917 55.8978L44.6667 65.2728C44.9875 65.5933 45.3742 65.8402 45.7999 65.9963C46.2257 66.1524 46.6804 66.2139 47.1323 66.1767C47.5843 66.1394 48.0227 66.0042 48.4172 65.7805C48.8117 65.5568 49.1527 65.2499 49.4167 64.8811L65.0417 43.0061Z"
          fill="white"
        />
      </svg>
    </>
  );
}
